import { logError } from "@/lib/log";
// Soft piano-like arpeggios generated with Web Audio (no audio files).
const PROGRESSION = [[261.63, 329.63, 392.0, 523.25], [220.0, 261.63, 329.63, 440.0], [174.61, 220.0, 261.63, 349.23], [196.0, 246.94, 293.66, 392.0]];
const BEAT = 0.42;

const pluck = (ctx, out, freq, at, len) => {
  const g = ctx.createGain();
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(0.16, at + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, at + len);
  g.connect(out);
  [["triangle", 1, 1], ["sine", 2, 0.25]].forEach(([type, mult, vol]) => {
    const o = ctx.createOscillator();
    const v = ctx.createGain();
    o.type = type; o.frequency.value = freq * mult; v.gain.value = vol;
    o.connect(v).connect(g);
    o.start(at); o.stop(at + len + 0.05);
  });
};

// Schedules ~durationMs of melody into `dest`; returns a stop() function.
export const playMelody = (ctx, dest, durationMs) => {
  const out = ctx.createGain();
  const lowpass = ctx.createBiquadFilter();
  lowpass.type = "lowpass"; lowpass.frequency.value = 2200;
  out.connect(lowpass).connect(dest);
  const t0 = ctx.currentTime + 0.05;
  const end = t0 + durationMs / 1000;
  out.gain.setValueAtTime(1, t0);
  out.gain.setValueAtTime(1, end - 1.5);
  out.gain.linearRampToValueAtTime(0, end);
  for (let i = 0, t = t0; t < end - 0.5; i++, t += BEAT) {
    const chord = PROGRESSION[Math.floor(i / 8) % PROGRESSION.length];
    pluck(ctx, out, chord[[0, 1, 2, 3, 2, 1, 2, 1][i % 8]], t, 1.6);
    if (i % 8 === 0) pluck(ctx, out, chord[0] / 2, t, 3.2);
  }
  return () => { try { out.disconnect(); } catch (e) { logError("Melody already stopped:", e); } };
};
